import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';

@Injectable({
  providedIn: 'root'
})

export class McXlsxService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFileFromAOA(aoa: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  
  public exportAsExcelFileFromTableDocumentElement(element: HTMLElement, excelFileName: string): void {
    var workbook = XLSX.utils.book_new();
    
    /* convert table 'table1' to worksheet named "Sheet1" */
    var ws1 = XLSX.utils.table_to_sheet(element);
    XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
    // let workbook = XLSX.utils.table_to_book(element);

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }









  public exportAsCSVFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + CSV_EXTENSION)
  }

  public exportAsCSVFileFromAOA(aoa: any[], excelFileName: string): void {
    // XLSX.writeFile(workbook, excelFileName + '_exportasdasd_' + new Date().getTime() + CSV_EXTENSION)
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'csv', type: 'buffer' });
    // this.saveAsCSVFile(excelBuffer, excelFileName);
    this.saveAsCSVFile(XLSX.utils.sheet_to_csv(worksheet), excelFileName);
  }
  
  public exportAsCSVFileFromTableDocumentElement(element: HTMLElement, excelFileName: string): void {
    var ws1 = XLSX.utils.table_to_sheet(element);
    this.saveAsCSVFile(XLSX.utils.sheet_to_csv(ws1), excelFileName);
  }

  private saveAsCSVFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'text/csv'
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + CSV_EXTENSION);
  }
}
